import { useContext } from "react";
import styles from "./LanguageChange.module.css";
import { Link, useNavigate } from "react-router-dom";
import DataContext from "../store/data-context";

const languageList = [
  {
    id: 0,
    lang: "hr",
  },
  {
    id: 1,
    lang: "de",
  },
];

export default function LanguageChange({ isMobile = false }) {
  const dataCtx = useContext(DataContext);

  const navigate = useNavigate();

  const changeLanguage = (e) => {
    const value = e.target.getAttribute("value");
    //dataCtx.setHash(value);
    navigate(`/${value}`);
    navigate(0);
  };

  return (
    <div className={styles[`wrapper`]}>
      <div
        className={`${styles["language-dropdown"]} ${
          styles[isMobile && "language-dropdown-mobile"]
        }`}
      >
        {languageList.map((language) => {
          return (
            <div
              className={`${
                styles[dataCtx.lang.id == language.id && "selected-language"]
              } ${
                styles[
                  dataCtx.lang.id == language.id &&
                    isMobile &&
                    "selected-language-mobile"
                ]
              } ${styles["language-option"]} ${
                styles[isMobile && "language-option-mobile"]
              }
              `}
              key={language.id}
              value={language.lang}
              onClick={changeLanguage}
            >
              {language.lang}
            </div>
          );
        })}
      </div>
    </div>
  );
}
